import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../public/img/pages/record-type-lookup/open-command-prompt-windows.png'
import _imports_1 from '../../public/img/pages/record-type-lookup/open-terminal-mac.png'
import _imports_2 from '../../public/img/pages/record-type-lookup/open-terminal-linux.png'


const _hoisted_1 = { class: "bg-neutral-100" }
const _hoisted_2 = { class: "container mx-auto" }
const _hoisted_3 = { class: "flex flex-col justify-center max-w-lg min-h-[calc(100vh-250px)] mx-auto text-center" }
const _hoisted_4 = {
  class: "text-base flex flex-col items-center justify-center",
  autocomplete: "off"
}
const _hoisted_5 = { class: "font-extrabold text-4xl max-w-full my-8" }
const _hoisted_6 = { class: "mt-8 mb-20 text-center max-w-full h-20 w-[500px] text-neutral-800" }
const _hoisted_7 = { class: "prose max-w-6xl prose-indigo mt-6 mx-auto bg-white p-6 rounded-t shadow" }
const _hoisted_8 = { class: "flex flex-col justify-between md:flex-row" }
const _hoisted_9 = { class: "inline-block text-2xl mt-0" }
const _hoisted_10 = { class: "shrink-0 flex items-center mb-5 text-sm font-medium leading-4 md:float-right" }
const _hoisted_11 = {
  type: "button",
  class: "inline-flex items-center rounded-md border border-[#3a0161] bg-white px-3 py-2 text-[#3a0161] shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
}
const _hoisted_12 = { class: "first-letter:uppercase" }
const _hoisted_13 = { class: "md:grid md:gap-6 md:grid-cols-2" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { key: 3 }
const _hoisted_18 = { key: 4 }
const _hoisted_19 = { key: 5 }
const _hoisted_20 = { key: 6 }
const _hoisted_21 = { key: 7 }
const _hoisted_22 = ["src", "alt"]
const _hoisted_23 = { id: "windows" }
const _hoisted_24 = ["src", "alt"]
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { id: "mac" }
const _hoisted_27 = ["src", "alt"]
const _hoisted_28 = { id: "linux" }
const _hoisted_29 = ["src", "alt"]
const _hoisted_30 = ["src", "alt"]
const _hoisted_31 = ["src", "alt"]

import { computed } from 'vue';
import { useRouter } from 'vue-router';
import HeaderComponent from '@/components/layout/HeaderComponent.vue';
import FooterComponent from '@/components/layout/FooterComponent.vue';
import DomainSearch from '@/components/DomainSearch.vue';
import DnsRecordsLink from '@/components/micro/DnsRecordsLink.vue';
import { getRecordType, recordTypes } from '@/common/recordTypes';
import Icon from '@/components/micro/IconComponent.vue';
import MetaTags from '@/components/MetaTags.vue';
import { LargeRectangle, MediumRectangle } from '@/common/adSizes';
import AdUnit from '@/components/ads/AdUnit.vue';
import { domainNameToUrlPath } from '@/common/domainName';
import { RecordTypeLookup } from '@/common/adSlots';


export default /*@__PURE__*/_defineComponent({
  __name: 'RecordTypeLookup',
  props: {
  routerRecordType: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const platforms: Array<'windows' | 'mac' | 'linux'> = [
  'windows',
  'mac',
  'linux',
];

const router = useRouter();

const recordType = computed(() => getRecordType(props.routerRecordType));

function redirectTo(domain: string): void {
  if (recordType.value.lower === 'spf') {
    router.push(`/domains/${domainNameToUrlPath(domain)}/email/${recordType.value.lower}/`);
  } else {
    router.push(`/domains/${domainNameToUrlPath(domain)}/dns-records/${recordType.value.lower}/`);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _createVNode(MetaTags, {
        title: `${recordType.value.upper} Lookup`,
        description: `Find ${recordType.value.plural} (${recordType.value.upper} DNS records) for any domain or website. Check if the ${recordType.value.upper} records have been configured correctly.`,
        url: `https://www.nslookup.io/${recordType.value.lower}-lookup/`
      }, null, 8, ["title", "description", "url"])
    ])),
    _createVNode(HeaderComponent, {
      "domain-search-to-url": (encodedDomain) => `/domains/${encodedDomain}/dns-records/${recordType.value.lower}/`,
      "search-button-text": `Find ${recordType.value.upper} records`
    }, null, 8, ["domain-search-to-url", "search-button-text"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("main", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("form", _hoisted_4, [
            _createElementVNode("h1", _hoisted_5, _toDisplayString(recordType.value.upper) + " lookup", 1),
            _createVNode(DomainSearch, {
              class: "h-12 mb-6 max-w-full w-[500px]",
              autofocus: "",
              emphasize: "",
              buttonText: ['soa', 'spf', 'cname'].includes(recordType.value.lower) ? `Find ${recordType.value.upper} record` : `Find ${recordType.value.upper} records`,
              "placeholder-text": recordType.value.upper === 'PTR' ? 'IP address or domain name' : 'Domain name',
              onSubmitted: redirectTo
            }, null, 8, ["buttonText", "placeholder-text"]),
            _createElementVNode("p", _hoisted_6, [
              _createTextVNode("Find all " + _toDisplayString(recordType.value.plural) + " for a domain name with this online DNS " + _toDisplayString(recordType.value.upper) + " checker. For example, try ", 1),
              _createVNode(DnsRecordsLink, {
                page: recordType.value.upper,
                domain: recordType.value.exampleDomains[0],
                class: "text-blue-600 hover:text-blue-800 hover:underline"
              }, null, 8, ["page", "domain"]),
              _cache[0] || (_cache[0] = _createTextVNode(" or ", -1)),
              _createVNode(DnsRecordsLink, {
                page: recordType.value.upper,
                domain: recordType.value.exampleDomains[1],
                class: "text-blue-600 hover:text-blue-800 hover:underline"
              }, null, 8, ["page", "domain"]),
              _createTextVNode(" to view their " + _toDisplayString(recordType.value.upper) + " records. ", 1)
            ]),
            _createVNode(AdUnit, {
              class: "mt-8 mx-auto",
              config: _unref(RecordTypeLookup)
            }, null, 8, ["config"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("h2", _hoisted_9, "How to lookup " + _toDisplayString(recordType.value.upper) + " records", 1),
            _createElementVNode("span", _hoisted_10, [
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "hidden mr-2 sm:inline" }, "Jump to", -1)),
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(platforms, (platform) => {
                return _createVNode(_component_router_link, {
                  key: platform,
                  to: `#${platform.toLowerCase()}`,
                  class: "no-underline mr-2 last:mr-0"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", _hoisted_11, [
                      _createVNode(Icon, {
                        icon: platform,
                        class: "mr-2"
                      }, null, 8, ["icon"]),
                      _createElementVNode("span", _hoisted_12, _toDisplayString(platform), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["to"])
              }), 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", null, [
              (recordType.value.upper === 'A')
                ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                    _cache[3] || (_cache[3] = _createTextVNode("A records can be configured by the owner of a domain name. They are used to link IPv4 addresses to a domain name. IPv6 addresses are stored as AAAA records. Both IPv4 and IPv6 addresses are most commonly used by web browsers like Google Chrome, in order to find the web server that should be contacted to display a website. Strictly speaking, A and AAAA records are not limited to this, but other uses are rare in comparison. ", -1)),
                    (recordType.value.learningPage !== undefined)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: recordType.value.learningPage
                        }, {
                          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                            _createTextVNode("Learn more about A records.", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"]))
                      : _createCommentVNode("", true)
                  ]))
                : (recordType.value.upper === 'AAAA')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                      _cache[5] || (_cache[5] = _createTextVNode("AAAA records can be configured by the owner of a domain name. They are used to link IPv4 addresses to a domain name. IPv6 addresses are stored as A records. Both IPv4 and IPv6 addresses are most commonly used by web browsers like Google Chrome, in order to find the web server that should be contacted to display a website. Strictly speaking, A and AAAA records are not limited to this, but other uses are rare in comparison. ", -1)),
                      (recordType.value.learningPage !== undefined)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: recordType.value.learningPage
                          }, {
                            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                              _createTextVNode("Learn more about AAAA records.", -1)
                            ]))]),
                            _: 1
                          }, 8, ["to"]))
                        : _createCommentVNode("", true)
                    ]))
                  : (recordType.value.upper === 'CNAME')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
                        _cache[7] || (_cache[7] = _createTextVNode("CNAME records can be configured by the owner of a domain name. They can be used to configure the same DNS records for two domain names without storing the information twice. When a domain name has a CNAME record pointing to another domain, that other domain name is said to be the canonical name for the domain with the CNAME record. ", -1)),
                        (recordType.value.learningPage !== undefined)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: recordType.value.learningPage
                            }, {
                              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                _createTextVNode("Learn more about CNAME records.", -1)
                              ]))]),
                              _: 1
                            }, 8, ["to"]))
                          : _createCommentVNode("", true)
                      ]))
                    : (recordType.value.upper === 'MX')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
                          _cache[9] || (_cache[9] = _createTextVNode("MX records can be configured by the owner of a domain name. They are used to store information in the DNS, which can be looked up by anyone. Each record type has a different purpose. The purpose of MX records is to publish the location of mail servers of a domain name. Whenever a mail client sends an email, it first looks up the MX records of the recipient. ", -1)),
                          (recordType.value.learningPage !== undefined)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: recordType.value.learningPage
                              }, {
                                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                  _createTextVNode("Learn more about MX records.", -1)
                                ]))]),
                                _: 1
                              }, 8, ["to"]))
                            : _createCommentVNode("", true)
                        ]))
                      : (recordType.value.upper === 'NS')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                            _cache[11] || (_cache[11] = _createTextVNode("NS records can be configured by the owner of a domain name. They are used to store the location of the authoritative DNS servers for that domain name. That means that these name servers will be seen as the source of truth for the DNS records for that domain name. Whenever a recursive DNS server doesn't have DNS records in its cache, it will trace the authoritative DNS server with NS lookups, and query that server for the DNS records. ", -1)),
                            (recordType.value.learningPage !== undefined)
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  to: recordType.value.learningPage
                                }, {
                                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                    _createTextVNode("Learn more about NS records.", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["to"]))
                              : _createCommentVNode("", true)
                          ]))
                        : (recordType.value.upper === 'SOA')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
                              _cache[13] || (_cache[13] = _createTextVNode("SOA records can be configured by the owner of a domain name. They are used to store information in the DNS, which can be looked up by anyone. Each record type has a different purpose. The purpose of SOA records is to announce that a new DNS zone starts somewhere in the tree of DNS names. An example is the delegation from a top level domain (e.g. .com) to the owner of a domain name (e.g. example.com). This start of authority contains some information about the child zone, which we explain in detail in our ", -1)),
                              (recordType.value.learningPage !== undefined)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    to: recordType.value.learningPage
                                  }, {
                                    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                      _createTextVNode("article about SOA records.", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["to"]))
                                : _createCommentVNode("", true)
                            ]))
                          : (recordType.value.upper === 'TXT')
                            ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
                                _cache[15] || (_cache[15] = _createTextVNode("TXT records can be configured by the owner of a domain name. They are used to store information in the DNS, which can be looked up by anyone. Each record type has a different purpose. TXT records are often used to verify domain ownership with third parties. A Sender Policy Framework (SPF) record can usually also be found with a TXT lookup. ", -1)),
                                (recordType.value.learningPage !== undefined)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      to: recordType.value.learningPage
                                    }, {
                                      default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                        _createTextVNode("Learn more about TXT records.", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["to"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("p", _hoisted_21, [
                                _createTextVNode(_toDisplayString(recordType.value.upper) + " records can be configured by the owner of a domain name. They are used to store information in the DNS, which can be looked up by anyone. Each record type has a different purpose. ", 1),
                                (recordType.value.learningPage !== undefined)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      to: recordType.value.learningPage
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Learn more about " + _toDisplayString(recordType.value.upper) + " records.", 1)
                                      ]),
                                      _: 1
                                    }, 8, ["to"]))
                                  : _createCommentVNode("", true)
                              ])),
              _createElementVNode("p", null, _toDisplayString(recordType.value.upper) + " records are configured in DNS. But how can you look up these " + _toDisplayString(recordType.value.upper) + " records? That depends on the operating system you are using. Windows, Linux and Mac all have a different way of finding " + _toDisplayString(recordType.value.upper) + " records. The sections below contain instructions for each operating system.", 1)
            ]),
            _createElementVNode("img", {
              class: "w-full md:mb-0 md:mt-6",
              src: `img/pages/record-type-lookup/${recordType.value.cli}-lookup-mac.png`,
              alt: `Example output of a ${recordType.value.upper} lookup query`
            }, null, 8, _hoisted_22)
          ]),
          _createElementVNode("h2", _hoisted_23, "How to lookup " + _toDisplayString(recordType.value.upper) + " records on Windows", 1),
          (recordType.value.windowsSupport)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("p", null, "To check the " + _toDisplayString(recordType.value.upper) + " records for a certain domain name on Windows, follow these steps:", 1),
                _createElementVNode("ol", null, [
                  _createElementVNode("li", null, [
                    _cache[20] || (_cache[20] = _createTextVNode("Open a ", -1)),
                    _cache[21] || (_cache[21] = _createElementVNode("em", null, "command prompt", -1)),
                    _cache[22] || (_cache[22] = _createTextVNode(" by navigating to ", -1)),
                    _createElementVNode("strong", null, [
                      _createVNode(Icon, { icon: "click" }),
                      _cache[16] || (_cache[16] = _createTextVNode(" Start → ", -1)),
                      _createVNode(Icon, { icon: "click" }),
                      _cache[17] || (_cache[17] = _createTextVNode(" 'Type here to search' → ", -1)),
                      _createVNode(Icon, { icon: "type" }),
                      _cache[18] || (_cache[18] = _createTextVNode(" 'cmd' → ", -1)),
                      _createVNode(Icon, { icon: "click" }),
                      _cache[19] || (_cache[19] = _createTextVNode(" Open", -1))
                    ]),
                    _cache[23] || (_cache[23] = _createTextVNode(".", -1)),
                    _cache[24] || (_cache[24] = _createElementVNode("img", {
                      loading: "lazy",
                      class: "block my-2 w-full border border-black/10 rounded-md shadow md:w-1/2",
                      src: _imports_0,
                      alt: "Open a command prompt in Windows",
                      width: "970",
                      height: "768"
                    }, null, -1))
                  ]),
                  _createElementVNode("li", null, [
                    _cache[27] || (_cache[27] = _createTextVNode("Type ", -1)),
                    _createElementVNode("strong", null, [
                      _createVNode(Icon, { icon: "type" }),
                      _cache[25] || (_cache[25] = _createTextVNode()),
                      _createElementVNode("code", null, "nslookup -q=" + _toDisplayString(recordType.value.cli) + " example.com", 1)
                    ]),
                    _cache[28] || (_cache[28] = _createTextVNode(" and hit ", -1)),
                    _createElementVNode("strong", null, [
                      _createVNode(Icon, { icon: "type" }),
                      _cache[26] || (_cache[26] = _createTextVNode(" [enter]", -1))
                    ]),
                    _createTextVNode(" to get the " + _toDisplayString(recordType.value.upper) + " records for ", 1),
                    _cache[29] || (_cache[29] = _createElementVNode("code", null, "example.com", -1)),
                    _cache[30] || (_cache[30] = _createTextVNode(".", -1)),
                    _createElementVNode("img", {
                      loading: "lazy",
                      class: "block my-2 w-full border border-black/10 rounded-md shadow md:w-1/2",
                      src: `img/pages/record-type-lookup/${recordType.value.cli}-lookup-windows.png`,
                      alt: `${recordType.value.upper} lookup in Windows`
                    }, null, 8, _hoisted_24)
                  ]),
                  _createElementVNode("li", null, [
                    _createTextVNode("The " + _toDisplayString(recordType.value.upper) + " records are listed below the ", 1),
                    _cache[31] || (_cache[31] = _createElementVNode("strong", null, "Non-authoritative answer", -1)),
                    _cache[32] || (_cache[32] = _createTextVNode(" heading.", -1))
                  ])
                ])
              ], 64))
            : (_openBlock(), _createElementBlock("p", _hoisted_25, [
                _createTextVNode("The " + _toDisplayString(recordType.value.upper) + " record type cannot be looked up in Windows. Neither ", 1),
                _cache[33] || (_cache[33] = _createElementVNode("code", null, "nslookup", -1)),
                _cache[34] || (_cache[34] = _createTextVNode(", nor Powershell's ", -1)),
                _cache[35] || (_cache[35] = _createElementVNode("code", null, "Resolve-DnsName", -1)),
                _createTextVNode(" has support for it. You can either install WSL and follow the Linux instructions below, or use an online " + _toDisplayString(recordType.value.upper) + " lookup tool like the one on the top of this page.", 1)
              ])),
          _createElementVNode("h2", _hoisted_26, "How to lookup " + _toDisplayString(recordType.value.upper) + " records on Mac OS", 1),
          _createElementVNode("p", null, "To check the " + _toDisplayString(recordType.value.upper) + " records for a certain domain name on a Mac, follow these steps:", 1),
          _createElementVNode("ol", null, [
            _createElementVNode("li", null, [
              _cache[39] || (_cache[39] = _createTextVNode("Open a ", -1)),
              _cache[40] || (_cache[40] = _createElementVNode("em", null, "terminal", -1)),
              _cache[41] || (_cache[41] = _createTextVNode(" by entering ", -1)),
              _createElementVNode("strong", null, [
                _createVNode(Icon, { icon: "type" }),
                _cache[36] || (_cache[36] = _createTextVNode(" [command] + [space] → ", -1)),
                _createVNode(Icon, { icon: "type" }),
                _cache[37] || (_cache[37] = _createTextVNode(" 'terminal.app' → ", -1)),
                _createVNode(Icon, { icon: "type" }),
                _cache[38] || (_cache[38] = _createTextVNode(" [enter]", -1))
              ]),
              _cache[42] || (_cache[42] = _createTextVNode(".", -1)),
              _cache[43] || (_cache[43] = _createElementVNode("img", {
                loading: "lazy",
                class: "block my-2 w-full border border-black/10 rounded-md shadow md:w-1/2",
                src: _imports_1,
                alt: "Open a terminal on a Mac",
                width: "1362",
                height: "862"
              }, null, -1))
            ]),
            _createElementVNode("li", null, [
              _cache[46] || (_cache[46] = _createTextVNode("Type ", -1)),
              _createElementVNode("strong", null, [
                _createVNode(Icon, { icon: "type" }),
                _cache[44] || (_cache[44] = _createTextVNode()),
                _createElementVNode("code", null, "dig example.com " + _toDisplayString(recordType.value.cli), 1)
              ]),
              _cache[47] || (_cache[47] = _createTextVNode(" and hit ", -1)),
              _createElementVNode("strong", null, [
                _createVNode(Icon, { icon: "type" }),
                _cache[45] || (_cache[45] = _createTextVNode(" [enter]", -1))
              ]),
              _createTextVNode(" to get the " + _toDisplayString(recordType.value.upper) + " records for ", 1),
              _cache[48] || (_cache[48] = _createElementVNode("code", null, "example.com", -1)),
              _cache[49] || (_cache[49] = _createTextVNode(".", -1)),
              _createElementVNode("img", {
                loading: "lazy",
                class: "block my-2 w-full border border-black/10 rounded-md shadow md:w-1/2",
                src: `img/pages/record-type-lookup/${recordType.value.cli}-lookup-mac.png`,
                alt: `${recordType.value.upper} lookup on a Mac`
              }, null, 8, _hoisted_27)
            ]),
            _createElementVNode("li", null, [
              _createTextVNode("The " + _toDisplayString(recordType.value.upper) + " records are listed below the ", 1),
              _cache[50] || (_cache[50] = _createElementVNode("strong", null, "ANSWER SECTION", -1)),
              _cache[51] || (_cache[51] = _createTextVNode(" heading.", -1))
            ])
          ]),
          _createElementVNode("h2", _hoisted_28, "How to lookup " + _toDisplayString(recordType.value.upper) + " records on Linux", 1),
          _createElementVNode("p", null, "To check the " + _toDisplayString(recordType.value.upper) + " records for a certain domain name on Linux, follow these steps:", 1),
          _createElementVNode("ol", null, [
            _createElementVNode("li", null, [
              _cache[55] || (_cache[55] = _createTextVNode("Open a ", -1)),
              _cache[56] || (_cache[56] = _createElementVNode("em", null, "terminal", -1)),
              _cache[57] || (_cache[57] = _createTextVNode(" by entering ", -1)),
              _createElementVNode("strong", null, [
                _createVNode(Icon, { icon: "type" }),
                _cache[52] || (_cache[52] = _createTextVNode(" [Super] → ", -1)),
                _createVNode(Icon, { icon: "type" }),
                _cache[53] || (_cache[53] = _createTextVNode(" 'terminal' → ", -1)),
                _createVNode(Icon, { icon: "type" }),
                _cache[54] || (_cache[54] = _createTextVNode(" [enter]", -1))
              ]),
              _cache[58] || (_cache[58] = _createTextVNode(".", -1)),
              _cache[59] || (_cache[59] = _createElementVNode("img", {
                loading: "lazy",
                class: "block my-2 w-full border border-black/10 rounded-md shadow md:w-1/2",
                src: _imports_2,
                alt: "Open a terminal in Linux",
                width: "754",
                height: "472"
              }, null, -1))
            ]),
            _createElementVNode("li", null, [
              _cache[62] || (_cache[62] = _createTextVNode("Type ", -1)),
              _createElementVNode("strong", null, [
                _createVNode(Icon, { icon: "type" }),
                _cache[60] || (_cache[60] = _createTextVNode()),
                _createElementVNode("code", null, "dig example.com " + _toDisplayString(recordType.value.cli), 1)
              ]),
              _cache[63] || (_cache[63] = _createTextVNode(" and hit ", -1)),
              _createElementVNode("strong", null, [
                _createVNode(Icon, { icon: "type" }),
                _cache[61] || (_cache[61] = _createTextVNode(" [enter]", -1))
              ]),
              _createTextVNode(" to get the " + _toDisplayString(recordType.value.upper) + " records for ", 1),
              _cache[64] || (_cache[64] = _createElementVNode("code", null, "example.com", -1)),
              _cache[65] || (_cache[65] = _createTextVNode(".", -1)),
              _createElementVNode("img", {
                loading: "lazy",
                class: "block my-2 w-full border border-black/10 rounded-md shadow md:w-1/2",
                src: `img/pages/record-type-lookup/${recordType.value.cli}-lookup-linux.png`,
                alt: `${recordType.value.upper} lookup in Linux`
              }, null, 8, _hoisted_29)
            ]),
            _createElementVNode("li", null, [
              _createTextVNode("The " + _toDisplayString(recordType.value.upper) + " records are listed below the ", 1),
              _cache[66] || (_cache[66] = _createElementVNode("strong", null, "ANSWER SECTION", -1)),
              _cache[67] || (_cache[67] = _createTextVNode(" heading.", -1))
            ])
          ]),
          _createElementVNode("h2", null, "How to find " + _toDisplayString(recordType.value.upper) + " records", 1),
          _createElementVNode("p", null, "To check the " + _toDisplayString(recordType.value.upper) + " records of a domain, follow these steps:", 1),
          _createElementVNode("ol", null, [
            _createElementVNode("li", null, [
              _cache[68] || (_cache[68] = _createTextVNode("Open the ", -1)),
              _createVNode(_component_router_link, {
                to: `/${recordType.value.lower}-lookup/`
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(recordType.value.upper) + " lookup tool", 1)
                ]),
                _: 1
              }, 8, ["to"]),
              _cache[69] || (_cache[69] = _createTextVNode(".", -1)),
              _createElementVNode("img", {
                loading: "lazy",
                class: "block my-2 w-full border border-black/10 rounded-md shadow md:w-1/2",
                src: `img/pages/record-type-lookup/${recordType.value.lower}-lookup-tool.png`,
                alt: `Open the ${recordType.value.upper} lookup tool`
              }, null, 8, _hoisted_30)
            ]),
            _createElementVNode("li", null, [
              _cache[71] || (_cache[71] = _createTextVNode("Enter the domain name and hit ", -1)),
              _createElementVNode("strong", null, [
                _createVNode(Icon, { icon: "type" }),
                _cache[70] || (_cache[70] = _createTextVNode(" [enter]", -1))
              ]),
              _cache[72] || (_cache[72] = _createTextVNode(".", -1)),
              _createElementVNode("img", {
                loading: "lazy",
                class: "block my-2 w-full border border-black/10 rounded-md shadow md:w-1/2",
                src: `img/pages/record-type-lookup/${recordType.value.lower}-records-example.png`,
                alt: `Example DNS ${recordType.value.upper} records`
              }, null, 8, _hoisted_31)
            ]),
            _createElementVNode("li", null, "The tool will query the " + _toDisplayString(recordType.value.upper) + " records and shown them at the top of the page.", 1)
          ]),
          (recordType.value.upper === 'CNAME')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _cache[74] || (_cache[74] = _createStaticVNode("<h2>What are CNAME records and how do they work?</h2><p>The DNS CNAME record can be configured to delegate the configuration of DNS records to some other DNS zone. In other words, it tells DNS clients (like web browsers) to query the DNS records of a different domain, and treat them as if they were for the domain with the CNAME record.</p><p>The most common use case for this is when you want to configure a custom domain name for a third party service. In this case you control your domain name, but the third party service controls the servers that host it. It would be inconvenient if you&#39;d have to change your DNS settings whenever this service changes its IP addresses. This is why they commonly request you to create a CNAME record instead. That way you remain in control of your domain name, but they can change the DNS configuration of their service at any time. When such a record exists for a domain name or subdomain, the content of the record is said to be the canonical name of that domain.</p><h2>Restrictions on CNAME records</h2><p>There are a couple of restrictions on the configuration of CNAME records:</p><ul><li>At most one CNAME record may exist for any domain or subdomain. See <a href=\"https://www.rfc-editor.org/rfc/rfc2181#section-10.1\" target=\"_blank\" rel=\"noopener noreferrer\">section 10.1 of RFC 2181</a>.</li><li>The content of a CNAME record must be a valid domain name. It cannot be an ip address. See <a href=\"https://www.rfc-editor.org/rfc/rfc1034#section-3.6\" target=\"_blank\" rel=\"noopener noreferrer\">section 3.6 of RFC 1034</a>.</li><li>If a CNAME record is present, no other records may be present, except for DNSSEC records (RRSIG, DNSKEY, DS, NSEC and NSEC3PARAM). See <a href=\"https://www.rfc-editor.org/rfc/rfc2181#section-10.1\" target=\"_blank\" rel=\"noopener noreferrer\">section 10.1 of RFC 2181</a>.</li><li>Root domains should not have a CNAME record. Because of the previous restriction, the root domain could no longer have NS or SOA records.</li><li>MX and NS records must not point to a domain name that has a CNAME record. See <a href=\"https://www.rfc-editor.org/rfc/rfc2181#section-10.3\" target=\"_blank\" rel=\"noopener noreferrer\">section 10.3 of RFC 2181</a>.</li></ul>", 6)),
                _createElementVNode("p", null, [
                  _createVNode(_component_router_link, { to: "/learning/dns-record-types/cname/" }, {
                    default: _withCtx(() => [...(_cache[73] || (_cache[73] = [
                      _createTextVNode("Learn more about CNAME records.", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ], 64))
            : _createCommentVNode("", true),
          _cache[77] || (_cache[77] = _createElementVNode("h2", { id: "otherLookup" }, "How to lookup other record types", -1)),
          _createElementVNode("p", null, [
            _createTextVNode("There are other types of DNS records then just " + _toDisplayString(recordType.value.upper) + ". The most commonly used DNS record types are A, AAAA, CNAME, NS, TXT, MX and SOA. If you'd like to look up all records of these record types, you can do so with ", 1),
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [...(_cache[75] || (_cache[75] = [
                _createTextVNode("nslookup", -1)
              ]))]),
              _: 1
            }),
            _cache[76] || (_cache[76] = _createTextVNode(". Click any of the record types below to find DNS records for that specific record type. ", -1))
          ]),
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(recordTypes).filter((other) => other.upper !== recordType.value.upper), (otherRecordType, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, [
                _createVNode(_component_router_link, {
                  to: `/${otherRecordType.lower}-lookup/`
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(otherRecordType.upper) + " lookup", 1)
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createTextVNode(" — " + _toDisplayString(otherRecordType.description), 1)
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createVNode(FooterComponent)
  ], 64))
}
}

})